import {required} from "vuelidate/lib/validators";  
const StrRiskDegerlendirmeKriterTablosu = {
    data() {
      return { 
        StrRiskDegerlendirmeKriterTablosuData:{  
            Baslangicdegeri: null,
            Bitisdegeri:null,
            Aralik:"", 
            Olasilik:"",  
            Etkistrateji:"",  
            Etkifaaliyetsurec:"", 
            Etkimali:"",  
            Etkimevzuatauyum: "",
            Deleted:false,
        },  
          FormDataType:{
            Baslangicdegeri:{FieldName:"Baslangicdegeri",Field:"input",FieldTitle:this.$t('StrRiskDegerlendirmeKriterTablosu.AddEdit.Baslangicdegeri')},
            Bitisdegeri:{FieldName:"Bitisdegeri",Field:"input",FieldTitle:this.$t('StrRiskDegerlendirmeKriterTablosu.AddEdit.Bitisdegeri')},
            Aralik:{FieldName:"Aralik",Field:"textarea",FieldTitle:this.$t('StrRiskDegerlendirmeKriterTablosu.AddEdit.Aralik')},
            Olasilik:{FieldName:"Olasilik",Field:"textarea",FieldTitle:this.$t('StrRiskDegerlendirmeKriterTablosu.AddEdit.Olasilik')},
            Etkistrateji:{FieldName:"Etkistrateji",Field:"textarea",FieldTitle:this.$t('StrRiskDegerlendirmeKriterTablosu.AddEdit.Etkistrateji')},
            Etkifaaliyetsurec:{FieldName:"Etkifaaliyetsurec",Field:"textarea",FieldTitle:this.$t('StrRiskDegerlendirmeKriterTablosu.AddEdit.Etkifaaliyetsurec')},
            Etkimali:{FieldName:"Etkimali",Field:"textarea",FieldTitle:this.$t('StrRiskDegerlendirmeKriterTablosu.AddEdit.Etkimali')},
            Etkimevzuatauyum:{FieldName:"Etkimevzuatauyum",Field:"textarea",FieldTitle:this.$t('StrRiskDegerlendirmeKriterTablosu.AddEdit.Etkimevzuatauyum')}
          }  
      } 
    },
    validations:{ 
      FormData: {
        Baslangicdegeri: { required },  
        Bitisdegeri: { required }, 
        Aralik: {required}, 
        Olasilik: {},  
        Etkistrateji: {},
        Etkifaaliyetsurec: {},
        Etkimali: {},  
        Etkimevzuatauyum: {}
      } 
  },
}
export default StrRiskDegerlendirmeKriterTablosu